import { ItineraryStatus } from '../models/itinerary';

export const getTextforPopup = (
  itineraryStatus: ItineraryStatus,
  arrangerName: string,
) => {
  const defaultText = {
    title: 'Send to arranger',
    message:
      // tslint:disable-next-line:max-line-length
      'Send your selected itinerary options to your arranger to have them continue this booking for you. Optionally add a message below.',
    noteHeading: `Notes from ${arrangerName}:`,
    input: 'Message',
    inputNote: 'This message will be included in the email to your arranger.',
    accept: 'Send',
    emailSent: 'Email sent',
    emailSentMessage:
      'An email has been sent to your arranger, who will complete the booking for you.',
    viewItinerary: 'View itinerary',
  };

  if (itineraryStatus === 'Accepted') {
    return {
      ...defaultText,
      title: 'Accept itinerary',
      message:
        // tslint:disable-next-line:max-line-length
        'An email will be sent to your arranger to notify them that you have accepted the recommended itinerary options. Optionally add a message below.',
    };
  }
  if (itineraryStatus === 'Rejected') {
    return {
      ...defaultText,
      title: 'Request changes',
      message:
        'Please add a comment to let your arranger know what needs to change. An email will be sent to your arranger.',
      noteHeading: '',
      input: 'Comment',
      inputNote: '',
      // tslint:disable-next-line:max-line-length
      emailSentMessage:
        'An email has been sent to your arranger, who will make the requested changes to your itinerary.',
    };
  }

  return defaultText;
};
